import AttributeTable from "../AttributeTable";
import withProfile from "../../hocs/withProfile";
const EnhancedTable = withProfile(AttributeTable);
export default EnhancedTable;
